import { EntityType } from '@frontend/common';
import { LabelTemplateContentClient } from '@frontend/label/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useLabelTemplateContent:request': CustomEvent<string>;
    }
}

const REQUEST_LABEL_TEMPLATE_CONTENT_EVENT = 'useLabelTemplateContent:request';
const STORAGE_KEY = 'LABELCONTENT_REQ';

export function labelTemplateContentRequest(labelTemplateContentId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_LABEL_TEMPLATE_CONTENT_EVENT, { detail: labelTemplateContentId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function LabelTemplateContentResolver(props: Props) {
    useResolver(
        STORAGE_KEY,
        REQUEST_LABEL_TEMPLATE_CONTENT_EVENT,
        EntityType.LABEL_TEMPLATE_CONTENT,
        (ids) => LabelTemplateContentClient.resolveLabelTemplateContents(ids),
        props.dispatch
    );
    return <></>;
}
